// extracted by mini-css-extract-plugin
export default {"SideBar__Text":"SideBar_SideBar__Text__IvM3D"};